import {
  EMPLOYEE_TICKET,
  EMPLOYEE_TICKET_DETAILS,
  EMPLOYEE_STATUS,
  EMPLOYEE_FILTER
} from "./type";

const initalState = {
  employeeTicket: {},
  employeeTicketDetails: {},
  employeeStatus: [],
  employeeFilterList: {}
};

const employeeTicketReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_TICKET:
      return {
        ...state,
        employeeTicket: payload,
      };
    case EMPLOYEE_TICKET_DETAILS:
      return {
        ...state,
        employeeTicketDetails: payload,
      };
    case EMPLOYEE_STATUS:
      return {
        ...state,
        employeeStatus: payload,
      };
      case EMPLOYEE_FILTER:
        return {
          ...state,
          employeeFilterList: payload,
        };
    default:
      return {
        ...state,
      };
  }
};

export default employeeTicketReducer;
